// import React from "react";
// import "../ReporteDocente.css";

// // Capitaliza la primera letra del texto
// const capitalize = (text) =>
//   text?.charAt(0).toUpperCase() + text?.slice(1).toLowerCase();

// const Autovaloracion = ({ docente, questions, answers,momento }) => {
//   const userAnswers = answers.find((a) => a.user === docente.user_id);

//   // Preguntas seleccionadas (puedes ajustarlas según necesidad)
//   const PREGUNTAS_MOSTRADAS = {
//     1:[339, 340, 343, 338],
//     2:[426, 434, 435, 436],
//     3:[656, 657, 658, 660]
//   }

//   if (!userAnswers) {
//     return (
//       <div className="card fortalezas-oportunidades-autovaloracion">
//         <div className="inferior">
//           <h3>Autovaloración</h3>
//           <p>
//             Estimado docente, recuerda realizar tu Autovaloración para que
//             puedas ver reflejado en esta sección tu reflexión personal sobre
//             logros y áreas a mejorar. Contamos con tu aporte para el próximo
//             Feedback 360.
//           </p>
//         </div>
//       </div>
//     );
//   }

//   const renderedAnswers = PREGUNTAS_MOSTRADAS[momento].map((questionId) => {
//     const question = questions.find((q) => q.id === questionId);
//     const answer = userAnswers.answers.find((a) => a.question === questionId);

//     return (
//       <div key={questionId} className="autovaloracion-item">
//         <div className="tarjeta">
//           <div className="descripcion">
//             <strong>{question?.label || question?.description || "Pregunta no disponible"}</strong>
//           </div>
//           <div className="icono">
//             <i className={question?.iconClass}></i>
//           </div>
//           <div className="respuesta">
//             {capitalize(answer?.content) || (
//               <span style={{ color: "#999" }}>
//                 No se tiene una respuesta registrada
//               </span>
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   });

//   const respuestasVacias = PREGUNTAS_MOSTRADAS[momento].every((questionId) => {
//     const answer = userAnswers.answers.find((a) => a.question === questionId);
//     return !answer?.content?.trim(); // vacío o undefined
//   });

//   return (
//     <div className="card fortalezas-oportunidades-autovaloracion">
//       <div className="inferior">
//         <h3>Autovaloración</h3>
//         {respuestasVacias ? (
//           <p>
//             Estimado docente, recuerda realizar tu Autovaloración para que
//             puedas ver reflejado en esta sección tu reflexión personal sobre
//             logros y áreas a mejorar. Contamos con tu aporte para el próximo
//             Feedback 360.
//           </p>
//         ) : (
//           <div className="autovaloracion-contenedor">{renderedAnswers}</div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Autovaloracion;

import React from "react";
import "../ReporteDocente.css";

// Capitaliza la primera letra del texto
const capitalize = (text) =>
  text?.charAt(0).toUpperCase() + text?.slice(1).toLowerCase();

const Autovaloracion = ({ docente, questions, answers }) => {
  const userAnswers = answers.find((a) => a.user === docente.user_id);

  if (!userAnswers) {
    return (
      <div className="card fortalezas-oportunidades-autovaloracion">
        <div className="inferior">
          <h3>Autovaloración</h3>
          <p>
            Estimado docente, recuerda realizar tu Autovaloración para que
            puedas ver reflejado en esta sección tu reflexión personal sobre
            logros y áreas a mejorar. Contamos con tu aporte para el próximo
            Feedback 360.
          </p>
        </div>
      </div>
    );
  }

  const renderedAnswers = questions.map((question) => {
    const answer = userAnswers.answers.find(
      (a) => a.question === question.id
    );

    return (
      <div key={question.id} className="autovaloracion-item">
        <div className="tarjeta">
          <div className="descripcion">
            <strong>{question.description}</strong>
          </div>
          <div className="respuesta">
            {answer?.content ? (
              capitalize(answer.content)
            ) : (
              <span style={{ color: "#999" }}>
                No se tiene una respuesta registrada
              </span>
            )}
          </div>
        </div>
      </div>
    );
  });

  const respuestasVacias = questions.every((question) => {
    const answer = userAnswers.answers.find(
      (a) => a.question === question.id
    );
    return !answer?.content?.trim();
  });

  return (
    <div className="card fortalezas-oportunidades-autovaloracion">
      <div className="inferior">
        <h3>Autovaloración</h3>
        {respuestasVacias ? (
          <p>
            Estimado docente, recuerda realizar tu Autovaloración para que
            puedas ver reflejado en esta sección tu reflexión personal sobre
            logros y áreas a mejorar. Contamos con tu aporte para el próximo
            Feedback 360.
          </p>
        ) : (
          <div className="autovaloracion-contenedor">
            {renderedAnswers}
          </div>
        )}
      </div>
    </div>
  );
};

export default Autovaloracion;
